import type {Schemas} from 'domainTypes/dto';
import type {ManifestationV4} from 'services/metadata/types';
import {ebsApi} from 'store/ebsApi';

const receiveItemsApi = ebsApi.injectEndpoints({
  endpoints: build => ({
    markPhysicalContentReceived: build.mutation<
      Schemas.PhysicalContentReceivedResponse,
      Pick<ManifestationV4, 'ean'>,
      Schemas.PhysicalContentReceivedResponse
    >({
      query: ({ean}) => ({
        url: `manifestation/${ean}/physicalcontentreceived`,
        method: 'POST',
      }),
    }),
  }),
});

export const {useMarkPhysicalContentReceivedMutation} = receiveItemsApi;
